export default __webpack_public_path__ + "static/media/target-12@3x.b1707261.png";